import { IconButton } from '@eventbrite/eds-icon-button';
import { HeartChunky, HeartFillChunky } from '@eventbrite/eds-iconography';
import { withTooltip } from '@eventbrite/eds-tooltip';
import { gettext } from '@eventbrite/i18n';
import loadable from '@loadable/component';
import React, { useContext, useState } from 'react';
import { UserContext } from '../../context';
import './Bookmark.scss';

export type BookmarkProps = {
    isBookmarkedEvent: boolean;
    eventId: string;
    onClickLoggedIn: () => void;
};

const STYLE_BRAND = 'brand';
const STYLE_NEUTRAL = 'neutral';

const LazyBookmarkModalLoggedOut = loadable(
    () => import('./BookmarkModalLoggedOut'),
);

const bookmarkedEventLookup = (isBookmarked: boolean) =>
    isBookmarked
        ? {
              className: 'bookmark is-active',
              iconType: <HeartFillChunky />,
              iconStyle: STYLE_BRAND,
          }
        : {
              className: 'bookmark',
              iconType: <HeartChunky />,
              iconStyle: STYLE_NEUTRAL,
          };

export const Bookmark = (props: BookmarkProps) => {
    const { eventId, isBookmarkedEvent, onClickLoggedIn } = props;
    const { isAuthenticated } = useContext(UserContext);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const isBookmarkedEventProps = bookmarkedEventLookup(isBookmarkedEvent);

    const IconButtonWithTooltip = withTooltip(IconButton);

    const handleClickLoggedOut = () => {
        setIsModalVisible(true);
    };

    return (
        <>
            {isAuthenticated ? (
                <div className={isBookmarkedEventProps.className}>
                    <IconButton
                        aria-pressed={isBookmarkedEvent}
                        iconType={isBookmarkedEventProps.iconType}
                        style={isBookmarkedEventProps.iconStyle}
                        title={gettext('Like Event')}
                        onClick={onClickLoggedIn}
                    />
                </div>
            ) : (
                <>
                    <div className={isBookmarkedEventProps.className}>
                        <IconButtonWithTooltip
                            aria-pressed="false"
                            iconType={<HeartChunky />}
                            tooltipId="tooltip-bookmark"
                            tooltipStyle="basic"
                            title={gettext('Like Event')}
                            tooltipText={gettext('Like Event')}
                            style={STYLE_NEUTRAL}
                            onClick={handleClickLoggedOut}
                        />
                    </div>
                    {isModalVisible && (
                        <LazyBookmarkModalLoggedOut
                            visible={isModalVisible}
                            onClose={() => setIsModalVisible(false)}
                            eventId={eventId}
                        />
                    )}
                </>
            )}
        </>
    );
};

export default Bookmark;
